export const environment = {
    production: false,
    name: 'dev',
    api_URL:'https://dev.circledplus.com/api',
    brevoApiKey: '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',
    brevoListId: 4,
    enableDebug: true,
    cashfreeMode: 'sandbox' as 'sandbox' | 'production'
  }
  